import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { isPersonTravellingWith } from '../../../../../utilities/pages';

function VisaPrepFamilyStep2(props: IVisaPrepForm) {
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.FATHERS_PERSONAL_DETAILS}
        label={`Do you have your Father's personal details?`}
        value={boolToYesNo(props.hasFathersPersonalDetails)}
      />
      {props.hasFathersPersonalDetails === true ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_NATIONALITY}
            value={props.fatherNationality}
            label={`Father's Nationality`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_SAME_NATIONALITY}
            label={'Have they always had the same nationality?'}
            value={boolToYesNo(props.fatherSameNationality)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_FAMILY_NAME}
            value={props.fatherFamilyName}
            label={`Father's Family Name`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_GIVEN_NAME}
            value={props.fatherGivenName}
            label={`Father's Given Name`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_DOB}
            label={`Father's Date of Birth`}
            value={props.fatherDob}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_PLACE_OF_BIRTH}
            value={props.fatherPlaceOfBirth}
            label={`Father's Place of birth`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_TRAVELLING_WITH}
            label={'Is this person travelling with you?'}
            value={props.fatherTravellingWith}
          />
          {isPersonTravellingWith(props.fatherTravellingWith) ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FATHER_UK_VISA}
                label={'Do they have a visa for the UK?'}
                value={props.fatherUkVisa}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FATHER_HAS_PASSPORT}
                label={'Do they have a Passport or Travel Document?'}
                value={boolToYesNo(props.fatherHasPassport)}
              />
              {props.fatherHasPassport ? (
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.FATHER_PASSPORT_NUMBER}
                  value={props.fatherPassportNumber}
                  label={'Current Passport or Travel Document Number:'}
                />
              ) : null}
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepFamilyStep2;
